import { render, staticRenderFns } from "./miniLinckard.vue?vue&type=template&id=4c972620"
import script from "./miniLinckard.vue?vue&type=script&lang=js"
export * from "./miniLinckard.vue?vue&type=script&lang=js"
import style0 from "./miniLinckard.vue?vue&type=style&index=0&id=4c972620&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports